module.exports = __webpack_public_path__ + "assets/img/barrel-idle.069b4957.png";